import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import trans from 'counterpart';
import ObjectPreference from './ObjectPreference';
import PropertyPreference from './PropertyPreference';
import {
  preferencesForReservationSelector,
  propertyFilterCountSelector,
  resourceInReservationSelector,
} from '../selectors';

const PreferencesForm = ({ preferences, counts, resource }) => {
  const paidPreferences = (preferences) ? preferences.filter(p => p.has_preference_costs || p.property.preference_costs) : [];
  const preferenceCosts = (resource && resource.kind.id === 5) ? '9,95' : trans('preferences.costs');

  return (
    <div className="mt-3">
      {process.env.RAZZLE_APP === 'beeksebergen' && (
        <Fragment>
          <h5 className="mt-0 mb-1 text-info text-lato">
            {trans('preferences.label')}
            {/* <InfoPopover content={properties.preference_costs_info} /> */}
          </h5>
          <p
            className="mb-2"
            dangerouslySetInnerHTML={{
              __html: (resource && resource.preferences_text) ? resource.preferences_text : `${trans('preferences.location')} € ${preferenceCosts}.`
            }}
          />
        </Fragment>
      )}
      {process.env.RAZZLE_APP === 'dierenbos' && resource && resource.preferences_text && (
        <Fragment>
          <h5 className="mt-0 mb-1 text-info text-lato">
            {trans('preferences.label')}
            {/* <InfoPopover content={properties.preference_costs_info} /> */}
          </h5>
          <p
            className="mb-2"
            dangerouslySetInnerHTML={{
              __html: resource.preferences_text
            }}
          />
        </Fragment>
      )}

      <div className="row">
        {paidPreferences.map(preference => (
          <PropertyPreference {...preference.property} count={counts[preference.property.id]} key={preference.property.id} />
        ))}
        <ObjectPreference />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  preferences: preferencesForReservationSelector(state),
  counts: propertyFilterCountSelector(state),
  resource: resourceInReservationSelector(state),
});

PreferencesForm.propTypes = {
  preferences: PropTypes.array,
  counts: PropTypes.object,
  resource: PropTypes.object,
};

export default connect(
  mapStateToProps
)(PreferencesForm);
